import styled from 'styled-components';

export const HeaderStyled = styled.div`
  align-self: center;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndices.header};

  > div {
    height: 100%;
  }
`;
